import ReplaceMenuProvider from "bpmn-js/lib/features/popup-menu/ReplaceMenuProvider";
import * as replaceOptions from "bpmn-js/lib/features/replace/ReplaceOptions";

import store from "../../index";
import { FrendsRuleProvider, ProcessMode } from "../FrendsRules/FrendsRuleProvider";

import { updateSelectedTriggerType } from "../../actions/UpdateSelectedType";
import { Triggers } from "../ITriggerData";

ReplaceMenuProvider.prototype._createMenuEntry = (definition, element, action) => {

  const replaceAction = () => {
    const defaultParameters = (Triggers[definition.actionName] as any).defaultConfig;
    store.dispatch(updateSelectedTriggerType(element.id, definition.actionName, defaultParameters) as any);
  };

  action = action || replaceAction;

  const menuEntry = {
    label: definition.label,
    className: definition.className,
    id: definition.actionName,
    action: action
  };

  return menuEntry;
};

export default function RestrictTransformationProvider() {
  // this takes the static defined replacement options and removes unwanted replacement options.
  // TODO: Surely there is a nicer / more straight-forward way to filter this...
  const options = replaceOptions;
  options.START_EVENT.length = 0;

  if (FrendsRuleProvider.getProcessMode() === ProcessMode.Process) {
    options.START_EVENT.push(
      {
        label: Triggers.FileWatchTrigger.displayName,
        actionName: Triggers.FileWatchTrigger.triggerType,
        className: "bpmn-icon-start-event-condition",
        target: {
          type: "bpmn:StartEvent",
          eventDefinitionType: `NOTUSED`
        }
      });

    options.START_EVENT.push(
      {
        label: Triggers.ScheduleTrigger.displayName,
        actionName: Triggers.ScheduleTrigger.triggerType,
        className: "bpmn-icon-start-event-timer",
        target: {
          type: "bpmn:StartEvent",
          eventDefinitionType: `NOTUSED`
        }
      });

    options.START_EVENT.push({
      label: Triggers.ConditionalTrigger.displayName,
      actionName: Triggers.ConditionalTrigger.triggerType,
      className: "bpmn-icon-start-event-signal",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });

    options.START_EVENT.push({
      label: Triggers.HttpTrigger.displayName,
      actionName: Triggers.HttpTrigger.triggerType,
      className: "bpmn-icon-start-event-message",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });

    options.START_EVENT.push({
      label: Triggers.HttpApiTrigger.displayName,
      actionName: Triggers.HttpApiTrigger.triggerType,
      className: "bpmn-icon-start-event-message",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });

    options.START_EVENT.push({
      label: Triggers.QueueTrigger.displayName,
      actionName: Triggers.QueueTrigger.triggerType,
      className: "bpmn-icon-start-event-message",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });

    options.START_EVENT.push({
      label: Triggers.ServiceBusTrigger.displayName,
      actionName: Triggers.ServiceBusTrigger.triggerType,
      className: "bpmn-icon-start-event-message",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });

    options.START_EVENT.push({
      label: Triggers.RabbitMQTrigger.displayName,
      actionName: Triggers.RabbitMQTrigger.triggerType,
      className: "bpmn-icon-start-event-message",
      target: {
        type: "bpmn:StartEvent",
        eventDefinitionType: `NOTUSED`
      }
    });
  }
  options.END_EVENT.length = 0; // = []; // End event should never be anything but end event
  options.SUBPROCESS_EXPANDED.length = 0; // = []; // If we want to use the expand/collapse functionality we'll do it with our own toggle. 
  options.SEQUENCE_FLOW.length = 0; // = []; // We don't want to support all strange flows possible - we'll controll the flow transformations outside of the tranformation menu
  options.INTERMEDIATE_EVENT.length = 0; // = []; // Catch and throw works in very different way with different restrictions, transformation should not be possible.
  options.TASK.length = 0; // = options.TASK
  // .filter((x) => ElementFactory.getElementType(x.target.type) != null
  //   && x.label !== "Sub Process (collapsed)"
  //   && x.label !== "Script Task"); // We don't want to transform into script task due to rendering issues. A non-expanded subprocess is if no use.
  options.GATEWAY.length = 0; // = []; // We don't allow transforming gateways since it'll make it possible to override the exclusive gateway 2 outgoing connection limit. 
}
